import { loader } from '@monaco-editor/react';
import * as monaco from 'monaco-editor';

/**
 * This is a self-hosted internal tool — Monaco must not be fetched from a public CDN
 * at runtime (the default @monaco-editor/react behavior). Point the loader at the
 * monaco-editor package bundled into our own build instead.
 */
loader.config({ monaco });
